"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Flatfile = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@flatfile/react");
var _Button = require("../Button");
var _Icon = require("../Icon");
var _eventBus = _interopRequireDefault(require("../eventBus"));
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* istanbul ignore file */

const Flatfile = props => {
  let flatFileImporter = '';
  const {
    buttonText,
    flatfileLicenseKey,
    fields,
    type,
    title,
    allowInvalidSubmit,
    maxRecords,
    styleOverrides,
    companyId,
    companyName,
    email,
    name,
    userId,
    flatfileData,
    flatfileRecordChange,
    flatfileRecordInit,
    flatfileFieldHooks,
    flatfileClose,
    devMode,
    renderButton,
    i18nOverrides,
    preventAutoTrimming,
    handleUserSession
  } = props;
  const [isFlatfile, showFlatfileButton] = (0, _react.useState)(false);
  const progressBarUpdate = msg => {
    flatFileImporter.displayLoader(msg);
  };
  const customButton = launch => {
    flatFileImporter?.$ready?.then(() => {
      showFlatfileButton(true);
    });
    const verifyUserSession = () => {
      handleUserSession();
      launch();
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderButton ? /*#__PURE__*/_react.default.cloneElement(renderButton, {
      onClick: isFlatfile ? verifyUserSession : () => {},
      className: `${isFlatfile ? '' : 'disabled'}`
    }) : /*#__PURE__*/_react.default.createElement(_Button.Button, {
      style: {
        backgroundColor: '#2D6BFF',
        borderColor: '#2D6BFF'
      },
      buttontext: buttonText ? buttonText : `Import ${type}`,
      onClick: isFlatfile ? verifyUserSession : () => {},
      className: `${isFlatfile ? '' : 'disabled'}`,
      icon: /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
        icon: ['fas', 'plus'],
        size: "1x"
      })
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flatfile"
  }, /*#__PURE__*/_react.default.createElement(_react2.FlatfileButton, {
    settings: {
      devMode: devMode,
      managed: true,
      type,
      title,
      fields,
      allowInvalidSubmit,
      maxRecords,
      styleOverrides: {
        ...styleOverrides
      },
      i18nOverrides: {
        ...i18nOverrides
      },
      preventAutoTrimming: preventAutoTrimming
    },
    licenseKey: flatfileLicenseKey,
    customer: {
      companyId,
      companyName,
      email,
      name,
      userId
    },
    onData: async results => {
      let flatfileResponse = {};
      flatFileImporter.on("close", () => {
        flatfileClose(flatfileResponse?.errorJson);
      });
      flatfileResponse = await flatfileData(results, progressBarUpdate);
      _eventBus.default.dispatch("updateTable", {
        data: results.validData,
        type: type
      });
      return flatfileResponse.successMessage;
    },
    onRecordChange: record => flatfileRecordChange(record),
    onRecordInit: record => flatfileRecordInit(record),
    fieldHooks: {
      ...flatfileFieldHooks
    },
    render: (importer, launch) => {
      flatFileImporter = importer;
      return customButton(launch);
    }
  }));
};
exports.Flatfile = Flatfile;
Flatfile.defaultProps = {
  title: '',
  maxRecords: 1000,
  allowInvalidSubmit: false,
  devMode: true,
  preventAutoTrimming: false,
  styleOverrides: {
    borderRadius: '4px',
    containerBorderTop: '',
    primaryButtonColor: '#794CFF',
    primaryButtonBorderColor: '#794CFF',
    // only works for :hover
    primaryButtonFontSize: '1.6rem',
    primaryButtonFontColor: '#fff',
    secondaryButtonColor: '#8b99a4',
    secondaryButtonBorderColor: '#8b99a4',
    secondaryButtonFontSize: '1.6rem',
    secondaryButtonFontColor: '#fff',
    noButtonColor: '',
    noButtonBorderColor: '',
    noButtonFontColor: '',
    yesButtonColor: '',
    yesButtonBorderColor: '',
    yesButtonFontColor: '#fff',
    invertedButtonColor: '#667d8d',
    linkColor: '#c6d1dd',
    linkAltColor: '#4a90e2',
    primaryTextColor: '#1D2830',
    secondaryTextColor: '#',
    errorColor: '',
    successColor: '#60b700',
    warningColor: '#f6A623',
    borderColor: '#e8e8e8',
    fontFamily: 'inherit'
  },
  companyId: '',
  companyName: 'Storybook',
  email: '',
  name: 'Storybook',
  userId: '',
  flatfileData: (results, progressBarUpdate) => {
    progressBarUpdate('uploading...');
    return 'Success';
  },
  flatfileRecordChange: () => {},
  flatfileRecordInit: () => {},
  flatfileFieldHooks: {},
  flatfileClose: () => {},
  handleUserSession: () => {}
};
Flatfile.propTypes = {
  /** In order to work, you have to pass in the license key.
   * You can find your license key in your dashboard by logging in https://app.flatfile.io/login. */
  flatfileLicenseKey: _propTypes.default.string.isRequired,
  /** This field refers to the type of import you have. (Example: Ad Units) */
  type: _propTypes.default.string.isRequired,
  /** Define your schema or data model that you want to receive in your application. */
  fields: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
  /** Title allows for you to pass an optional title to the Flatfile Importer page.
   * This will override type prop. */
  title: _propTypes.default.string,
  /** Specify a maximum number of records that a file can import. */
  maxRecords: _propTypes.default.number,
  /** Either allow or not allow a user to submit with errors in the data */
  allowInvalidSubmit: _propTypes.default.bool,
  /** Set the importer as being in development mode. */
  devMode: _propTypes.default.bool,
  /** This allows for customization of the appearance of the importer. */
  preventAutoTrimming: _propTypes.default.bool,
  /** This flag is to toggle the triming behaviour for on-change event*/
  styleOverrides: _propTypes.default.shape({
    borderRadius: _propTypes.default.string,
    containerBorderTop: _propTypes.default.string,
    primaryButtonColor: _propTypes.default.string,
    primaryButtonBorderColor: _propTypes.default.string,
    // only works for :hover
    primaryButtonFontSize: _propTypes.default.string,
    primaryButtonFontColor: _propTypes.default.string,
    secondaryButtonColor: _propTypes.default.string,
    secondaryButtonBorderColor: _propTypes.default.string,
    secondaryButtonFontSize: _propTypes.default.string,
    secondaryButtonFontColor: _propTypes.default.string,
    noButtonColor: _propTypes.default.string,
    noButtonBorderColor: _propTypes.default.string,
    noButtonFontColor: _propTypes.default.string,
    yesButtonColor: _propTypes.default.string,
    yesButtonBorderColor: _propTypes.default.string,
    yesButtonFontColor: _propTypes.default.string,
    invertedButtonColor: _propTypes.default.string,
    linkColor: _propTypes.default.string,
    linkAltColor: _propTypes.default.string,
    primaryTextColor: _propTypes.default.string,
    secondaryTextColor: _propTypes.default.string,
    errorColor: _propTypes.default.string,
    successColor: _propTypes.default.string,
    warningColor: _propTypes.default.string,
    borderColor: _propTypes.default.string,
    fontFamily: _propTypes.default.string
  }),
  /** https://flatfile.com/developers/guides/custom-portal-text/ */
  i18nOverrides: _propTypes.default.shape(),
  /** Custom prop. Displays the button text*/
  buttonText: _propTypes.default.string,
  /** Internal ID for the company the user is currently operating under. Example: org_id */
  companyId: _propTypes.default.string,
  /** The company name the user is currently operating under. Example: org_name */
  companyName: _propTypes.default.string,
  /** An email address of user. */
  email: _propTypes.default.string,
  /** Name of user. */
  name: _propTypes.default.string,
  /** Internal ID reference for user */
  userId: _propTypes.default.string,
  /** This allows to write a new Promise to handle the Flatfile results with.
   * At the end it should return success message<string>.
   * */
  flatfileData: _propTypes.default.func,
  /**
   * This gives access to Flatfile's record hooks when a record changes.
   */
  flatfileRecordChange: _propTypes.default.func,
  /** This gives access to Flatfile's record hooks when a record initializes. */
  flatfileRecordInit: _propTypes.default.func,
  /** This allows you to pass in a field hooks as one or more callback functions in the prop. */
  flatfileFieldHooks: _propTypes.default.object,
  /** OnClose callback function for progress and success screen. */
  flatfileClose: _propTypes.default.func
};